"use client";

import Link from "next/link";
import Image from "next/image";
import { Check } from "lucide-react";
import { useLocale } from "@/context/LocaleContext";

export default function AllInOneFeature() {
  const { t } = useLocale(); 

  const featureListLeft = [
    t("AllInOne.feat_l_1") || "Bebas ganti ke semua tema",
    t("AllInOne.feat_l_2") || "Ubah nama tamu unlimited",
    t("AllInOne.feat_l_3") || "Tanpa masa aktif",
    t("AllInOne.feat_l_4") || "Rsvp & ucapan",
    t("AllInOne.feat_l_5") || "Terintegrasi google maps",
    t("AllInOne.feat_l_6") || "Sebar ke unlimited penerima",
    t("AllInOne.feat_l_7") || "Countdown menuju hari-h",
    t("AllInOne.feat_l_8") || "Pengingat google calendar",
    t("AllInOne.feat_l_9") || "Foto galeri & video",
    t("AllInOne.feat_l_10") || "Rekening titip hadiah",
    t("AllInOne.feat_l_11") || "Titip kado fisik ke acara",
    t("AllInOne.feat_l_12") || "Amplop digital di undangan",
    t("AllInOne.feat_l_13") || "Ratusan musik bisa custom"
  ];

  const featureListRight = [
    t("AllInOne.feat_r_1") || "Link live streaming",
    t("AllInOne.feat_r_2") || "Fitur auto scroll",
    t("AllInOne.feat_r_3") || "Ubah font dan warna tulisan",
    t("AllInOne.feat_r_4") || "Kostumisasi tema undangan",
    t("AllInOne.feat_r_5") || "Qr code buku tamu",
    t("AllInOne.feat_r_6") || "Layar sapa & check-in tamu",
    t("AllInOne.feat_r_7") || "Love story & susunan acara",
    t("AllInOne.feat_r_8") || "Fitur turut mengundang",
    t("AllInOne.feat_r_9") || "Laporan statistik sebar",
    t("AllInOne.feat_r_10") || "Embed map lokasi acara",
    t("AllInOne.feat_r_11") || "Balas ucapan tamu",
    t("AllInOne.feat_r_12") || "Unlimited revisi sepuasnya",
    t("AllInOne.feat_r_13") || "Ubah susunan komponen"
  ];

  return (
    <div className="w-full pt-28 md:pt-12 bg-gray-50 ">
      <section className="max-w-6xl min-h-[85vh] mx-auto px-4 md:px-8 bg-gray-50  flex flex-col justify-center">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 md:mb-8 leading-tight tracking-tight">
          {t("AllInOne.hero_title") || "All-In-One Undangan Digital Platform (Gratis)"}
        </h1>
        
        <h2 className="text-xl md:text-2xl lg:text-[28px] font-bold text-gray-900 mb-4 md:mb-5">
          {t("AllInOne.hero_subtitle") || "Semua Fitur Dasar Undangan Digital, Sudah Termasuk"}
        </h2>
        
        <p className="text-gray-800 text-[15px] md:text-lg leading-relaxed mb-4 md:mb-5">
          <span className="font-bold text-gray-900">Elynk.Co</span> <span dangerouslySetInnerHTML={{ __html: t("AllInOne.hero_desc") || "adalah platform undangan digital yang dirancang agar kamu bisa membuat undangan dengan <b>lengkap</b>, <b>rapi</b>, dan <b>profesional</b>, tanpa perlu biaya dan tanpa batas waktu. <br/>" }} />
        </p>
        
        <div>
           <h5 className="md:text-xl text-md mb-2">{t("AllInOne.list_heading") || "Semua fitur dasar undangan digital sudah tersedia dan bisa langsung digunakan:"}</h5>
            <ul className="list-disc pl-4 space-y-1.5 md:space-y-2 mb-4 md:mb-5 text-gray-900 text-[15px] md:text-lg">
              <li className="font-bold">{t("AllInOne.list_item_1") || "Gratis"}</li>
              <li className="font-bold">{t("AllInOne.list_item_2") || "Bisa Disebar Unlimited"}</li>
              <li className="font-bold">{t("AllInOne.list_item_3") || "Tanpa Masa Aktif"}</li>
            </ul>
        </div>
        
        <p className="text-gray-800 text-[15px] md:text-lg leading-relaxed mb-8 md:mb-10">
          {t("AllInOne.no_upgrade_needed") || "Kamu tidak perlu upgrade hanya untuk menggunakan fitur penting undangan."}
        </p>

        <div>
          <Link href="/add-event" className="inline-block">
            <button className="bg-[#E85C57] hover:bg-[#d64c47] text-white font-bold text-[15px] md:text-lg py-3 px-8 md:py-3.5 md:px-10 rounded-xl transition-all shadow-md hover:shadow-lg">
              {t("AllInOne.btn_create") || "Buat Gratis Sekarang"}
            </button>
          </Link>
        </div>
       
      </section>

      <section className="max-w-full  bg-white mx-auto px-4 md:px-44 py-10 md:py-16">
        <h2 className="text-xl md:text-2xl lg:text-[28px] font-bold text-gray-900 mb-4 md:mb-5">
          {t("AllInOne.meaning_title") || "Apa Maksudnya All-In-One?"}
        </h2>
        <p className="text-gray-800 text-[15px] md:text-lg leading-relaxed">
          {t("AllInOne.meaning_desc") || "All-in-One berarti kamu tidak perlu menggabungkan banyak tools atau layanan lain.Semua kebutuhan undangan digital,mulai dari tampilan, informasi acara, hingga pengalaman tamu sudah tersedia dalam satu platform.Cukup buat satu undangan, isi data, pilih tema, dan sebarkan."}
        </p>
      </section>

      <section className="w-full bg-gray-50 py-10 md:py-16 border-t border-gray-100">
        <div className="max-w-6xl mx-auto px-4 md:px-8 space-y-20">

          <div>
            <h2 className="text-xl md:text-[28px] font-bold text-gray-900 mb-8 md:mb-12 text-center md:text-left">
              {t("AllInOne.feature_20_title") || "20+ Fitur Undangan Digital Yang Kamu Dapatkan"}
            </h2>
            
            <div className="flex flex-col md:flex-row gap-10 lg:gap-16 items-center md:items-start">
              <div className="w-full md:w-[35%] flex justify-center md:justify-start">
                <div className="relative w-full max-w-[320px] aspect-[4/5] flex items-center justify-center">
                  <Image src="/images/cta/cta.png" alt="Mockup HP Elynk" fill className="object-contain drop-shadow-2xl" />
                </div>
              </div>

              <div className="w-full md:w-[65%] grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                <ul className="space-y-3 md:space-y-4">
                  {featureListLeft.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2.5 text-[14px] md:text-[16px] text-gray-800 font-medium">
                      <span className="text-gray-900 font-bold text-lg md:text-xl leading-none mt-[-2px] md:mt-[-1px]">•</span>
                      {item}
                    </li>
                  ))}
                </ul>
                <ul className="space-y-3 md:space-y-4">
                  {featureListRight.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2.5 text-[14px] md:text-[16px] text-gray-800 font-medium">
                      <span className="text-gray-900 font-bold text-lg md:text-xl leading-none mt-[-2px] md:mt-[-1px]">•</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="flex flex-col md:flex-row gap-6 md:gap-8 lg:gap-10 mt-16 md:mt-24">
            <div className="w-full md:w-[45%] lg:w-[40%] relative min-h-[350px] md:min-h-[450px] rounded-[32px] overflow-hidden shadow-sm">
               <Image 
                  src="/images/features/landing-page/all-in.webp" 
                  alt="Mockup Tema Elynk" 
                  fill 
                  className="object-cover" 
               />
            </div>
            <div className="w-full md:w-[55%] lg:w-[60%] bg-white rounded-[32px] shadow-[0_15px_40px_-10px_rgba(0,0,0,0.05)] border border-gray-100 p-8 md:p-10 lg:p-14 flex flex-col justify-center">
              <h2 
                className="text-3xl md:text-4xl lg:text-[2.5rem] font-extrabold text-gray-900 leading-tight mb-6 tracking-tight"
                dangerouslySetInnerHTML={{ __html: t("AllInOne.free_box_title") || "Gratis, Unlimited,<br/>Tanpa Masa Aktif" }}
              />
              
              <p className="text-gray-800 text-[16px] md:text-[17px] mb-5 font-medium">
                {t("AllInOne.free_box_subtitle") || "Semua fitur undangan digital di atas:"}
              </p>
              
              <ul className="space-y-4 mb-8">
                <li className="flex items-center gap-3 text-[16px] md:text-[18px] text-gray-900">
                  <Check className="w-6 h-6 md:w-7 md:h-7 text-[#10b981]" strokeWidth={3.5} /> {t("AllInOne.free_box_list_1") || "Gratis digunakan"}
                </li>
                <li className="flex items-center gap-3 text-[16px] md:text-[18px] text-gray-900">
                  <Check className="w-6 h-6 md:w-7 md:h-7 text-[#10b981]" strokeWidth={3.5} /> {t("AllInOne.free_box_list_2") || "Bisa disebar unlimited"}
                </li>
                <li className="flex items-center gap-3 text-[16px] md:text-[18px] text-gray-900">
                  <Check className="w-6 h-6 md:w-7 md:h-7 text-[#10b981]" strokeWidth={3.5} /> {t("AllInOne.free_box_list_3") || "Tanpa masa aktif"}
                </li>
              </ul>
              
              <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed">
                {t("AllInOne.use_elynk_1") || "Gunakan"} <Link href={"/"}><span className="underline underline-offset-4 decoration-gray-300">Elynk.Co</span></Link> {t("AllInOne.use_elynk_2") || "tanpa batasan waktu dan tanpa biaya tersembunyi."}
              </p>
            </div>

          </div>

        </div>
      </section>

    </div>
  );
}